import React, { Component } from 'react'
import NavBarPortfolio from './components/navBarPortfolio'
// import './uicons-regular-rounded/css/uicons-regular-rounded.css'
import './style.scss'
import HomePage from './components/homePage'
import Setting from './components/setting'
import { Route, Routes } from 'react-router-dom'
import About from './components/about'
import Serivces from './components/serivces'
import Portfoli from './components/portfoli'
import Contactme from './components/contactme'

export default class MyPortfolioMainPage extends Component {
  state = {
    ulConent:[
      'Web deweleper',
      'Bloger',
      'Designer',
      'Junior',
    ],
  }
  render() {
    return (
        <>
          <NavBarPortfolio/>
          <Routes>
            <Route path='/' element={<HomePage anmContentText={this.state.ulConent} />} />
            <Route path='/about' element={<About />} />
            <Route path='/services' element={<Serivces />} />
            <Route path='/portfolio' element={<Portfoli />} />
            <Route path='/contact' element={<Contactme />} />b
          </Routes>
          <Setting />
        </>
    )
  }
}
